import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPakistan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1530)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 16.5485 2.53073 20.5056 6.26086 22.5409V1.45908C2.53073 3.49434 0 7.45148 0 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C9.9211 0 7.96575 0.528891 6.26086 1.45908V22.5409C7.96575 23.4711 9.9211 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.1306 13.9846C15.6125 15.0815 13.4925 14.74 12.3956 13.222C11.2987 11.7038 11.6402 9.58384 13.1583 8.48696C13.6316 8.14496 14.1635 7.94279 14.7046 7.87252C13.6636 7.71685 12.5632 7.95141 11.6427 8.61652C9.77431 9.96662 9.35398 12.5757 10.704 14.4443C12.0541 16.3127 14.6632 16.733 16.5318 15.3828C17.4523 14.7177 18.0205 13.7468 18.1995 12.7095C17.9629 13.201 17.604 13.6425 17.1306 13.9846Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0656 7.8262L17.9208 8.74781L19.0615 8.21944L18.4492 9.31744L19.3043 10.2391L18.0708 9.99609L17.4585 11.0942L17.3085 9.84591L16.0749 9.60286L17.2157 9.07448L17.0656 7.8262Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1530",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPakistan;
